import { ProcedureFieldValuesService as OvermapProcedureFieldValuesService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class ProcedureFieldValuesService extends OvermapProcedureFieldValuesService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
